import React from 'react'
import Joyride from 'react-joyride'
import { WalkthroughTooltip } from './WalkthroughTooltip'

const Walkthrough = ({
  run,
  steps,
  callback,
  continuous = true,
  styles,
  stepIndex,
  locale,
  ...props
}) => {
  const CustomTooltip = (props) => (
    //forwarding Joyride locale prop as translations to WalkthroughTooltip
    <WalkthroughTooltip {...props} translations={locale} />
  )

  return (
    <Joyride
      locale={locale}
      callback={callback}
      continuous={continuous}
      tooltipComponent={CustomTooltip}
      run={run}
      scrollOffset={10}
      scrollToFirstStep
      showProgress
      stepIndex={stepIndex}
      showSkipButton
      steps={steps}
      styles={{
        options: {
          zIndex: 10000,
          ...styles,
        },
      }}
      {...props}
    />
  )
}

export default Walkthrough
